import * as React from "react";
import { useParams } from "react-router-dom";

import KeyPermissionForm from "../../../components/Forms/KeyPermissions/FlowForm/FlowForm";

export default () => {
    const { id } = useParams();
  return <KeyPermissionForm method="PATCH" id={id}/>;
};
